export default __webpack_public_path__ + "static/andy-bitmoji-525c3c6e51aaf268e5e6bb287a8f210b.png";